<template>
  <el-descriptions title="" :column="colCount" colon>
    <el-descriptions-item v-for="col in Object.keys(colMap)" :key="col" :label="`${ colMap[ col ] }：`">
      {{ data[ col ] }}
    </el-descriptions-item>
</el-descriptions>
</template>

<script>
export default {
  name: 'Desci',

  props: {
    data: {
      type: Object,
      required: true
    },
    colMap: {
      type: Object,
      required: true
    },
    colCount: {
      type: Number,
      default: () => 1
    }
  }
}
</script>
